module.exports = "/pages/business/foodslabo/charm_image_1.jpg";